import { bindable, computedFrom } from 'aurelia-framework';

export class NmButton {
	@bindable type = 'button';
	@bindable size: string;
	@bindable color = 'default';
	@bindable buttonClass: string;
	@bindable click: (params: { event: Event }) => void;
	@bindable icon: string;

	@computedFrom('size')
	get sizeClass(): string {
		return this.size ? `btn-${this.size}` : '';
	}

	onClick(event: Event) {
		if (this.click != null) { this.click({ event }); }
	}
}
